<template>
  <el-row :gutter="10">
    <el-col :span="6"
            :xs="24"
            class="mb-15">
      <el-card shadow="none">
        <div slot="header">
          <el-input placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
        </div>
        <el-tree highlight-current
                 default-expand-all
                 class="room-tree"
                 ref="roomTree"
                 node-key="id"
                 :filter-node-method="filterNode"
                 :expand-on-click-node="false"
                 :data="treeData"
                 :props="defaultProps"
                 @node-click="handleNodeClick">
        </el-tree>
      </el-card>
    </el-col>
    <el-col :span="18"
            :xs="24">
      <el-card shadow="none">
        <div slot="header">
          <el-form :inline="true"
                   :model="workForm"
                   ref="work_form">
            <el-form-item label="上班时间:"
                          prop="tw_begin">
              <el-time-select v-model="workForm.tw_begin"
                              :picker-options="{
                                start: '00:00',
                                step: '00:01',
                                end: '24:00'
                              }"
                              placeholder="选择时间">
              </el-time-select>
            </el-form-item>
            <el-form-item label="下班时间:"
                          prop="tw_end">
              <el-time-select v-model="workForm.tw_end"
                              :picker-options="{
                                start: workForm.tw_begin,
                                step: '00:01',
                                end: '24:00',
                                minTime: workForm.tw_begin
                              }"
                              placeholder="选择时间">
              </el-time-select>
            </el-form-item>
            <el-form-item label="是否启用:"
                          prop="enabled">
              <el-select v-model="workForm.enabled"
                         placeholder="是否启用">
                <el-option value="1"
                           label="是"></el-option>
                <el-option value="0"
                           label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="timeSubmit('work_form')">确定
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-row class="mt-15 change-main"
                :gutter="10">
          <el-col :span="10"
                  :xs="24">
            <el-card shadow="none">
              <p class="item-title">门禁点位</p>
              <el-table :data="leftCheckData"
                        @selection-change="handleSelectionChange">
                <el-table-column type="selection"
                                 width="50"></el-table-column>
                <el-table-column label="设备备名称"
                                 prop="lock_name"
                                 :min-width="80"
                                 :show-overflow-tooltip="true">
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col class="mt-50 alignCenter"
                  :span="4"
                  :xs="24">
            <el-button type="primary"
                       :disabled="!rightCheckArr.length"
                       icon="el-icon-arrow-left"
                       @click="handleToLeft"></el-button>
            <el-button type="primary"
                       :disabled="!leftCheckArr.length"
                       icon="el-icon-arrow-right"
                       @click="handleToRihgt"></el-button>
          </el-col>
          <el-col :span="10"
                  :xs="24">
            <el-card shadow="none">
              <p class="item-title">考勤点位</p>
              <el-table :data="allSelect"
                        @selection-change="handleRightChange">
                <el-table-column type="selection"
                                 width="50"></el-table-column>
                <el-table-column label="设备名称"
                                 prop="lock_name"
                                 :min-width="80"
                                 :show-overflow-tooltip="true">
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="24"
                  class="alignCenter mt-20">
            <el-button type="primary"
                       @click="handleConfirm('work_form')">
              确 定
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      workForm: {
        tw_begin: '',
        tw_end: '',
        enabled: '1'
      },
      filterText: '',
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      treeData: [],
      // 模拟穿梭
      leftCheckArr: [],
      rightCheckArr: [],
      leftCheckData: [],
      rightCheckData: [],
      allSelect: []
    }
  },
  watch: {
    filterText(val) {
      this.$refs.roomTree.filter(val)
    }
  },
  created() {
    this.getTime()
    this.getAreaTree()
    this.getWorkLock()
  },
  methods: {
    getTime() {
      fetch.getTime({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            if (data.list && data.list.length) {
              this.workForm = data.list[0]
            }
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 左侧选中
    handleSelectionChange(val) {
      this.leftCheckArr = val
    },
    // 右侧选中
    handleRightChange(val) {
      this.rightCheckArr = val
    },
    // 左侧穿梭按钮
    handleToRihgt() {
      let checkedArr = this.leftCheckArr.map((item) => {
        return item.lock_id
      })
      this.leftCheckData = this.leftCheckData.filter((item) => {
        return checkedArr.indexOf(item.lock_id) < 0
      })
      this.rightCheckData = this.rightCheckData.concat(this.leftCheckArr)
      this.allSelect = this.allSelect.concat(this.leftCheckArr)
    },
    // 右侧穿梭按钮
    handleToLeft() {
      let checkedArr = this.rightCheckArr.map((item) => {
        return item.lock_id
      })
      this.rightCheckData.forEach((item) => {
        if (checkedArr.indexOf(item.lock_id) > -1) {
          this.leftCheckData.push(item)
        }
      })
      this.rightCheckData = this.rightCheckData.filter((item) => {
        return checkedArr.indexOf(item.lock_id) < 0
      })
      // this.leftCheckData = this.leftCheckData.concat(this.rightCheckArr)
      let tmpAllArr = []
      this.allSelect.forEach((item) => {
        if (checkedArr.indexOf(item.lock_id) < 0) {
          tmpAllArr.push(item)
        }
      })
      this.allSelect = tmpAllArr
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 获取已有权限
    getWorkLock() {
      fetch.getWorkLock({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.allSelect = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取树结构数据
    getAreaTree() {
      return Promise.resolve(
        //fetch.getAreaTreeManage({}).then((data) => {
        fetch.getAreaTree({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.treeData = data.treeData
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    // 获取设备列表
    roomLockList(val) {
      fetch.roomLockList({ area_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            let leftArr = []
            let rightArr = []
            let allSelectIds = this.allSelect.map((item) => {
              return item.lock_id
            })
            data.list.forEach((item) => {
              if (allSelectIds.indexOf(item.lock_id) < 0) {
                leftArr.push(item)
              } else {
                rightArr.push(item)
              }
            })
            this.leftCheckData = leftArr
            this.rightCheckData = rightArr
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 树形菜单单击
    handleNodeClick(data) {
      this.leftCheckData = []
      this.rightCheckData = []
      if (data.area_type === 'area_type_yes') {
        this.roomLockList(data.id)
      } else {
        this.$message.info('该机构下暂无设备数据')
      }
    },
    timeSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.setTime({ ...this.workForm }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.getTime()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleConfirm() {
      let lockStr = this.allSelect.map((item) => {
        return {
          id: item.id,
          lock_id: item.lock_id
        }
      })
      fetch.addWorkLock({ lockData: JSON.stringify(lockStr) }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getWorkLock()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less" scoped>
.change-main {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // align-items: center;
}
</style>
<style lang="less">
.authModal {
  .el-transfer-panel {
    width: 300px;
    .el-transfer-panel__item {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
